@if (icon) {
  <cs-icon [name]="icon"></cs-icon>
}
<ng-content select="cs-icon"></ng-content>
@if (label) {
  {{ label }}
}
<ng-content></ng-content>
@if (info) {
  <cs-tooltip [text]="info" [title]="label" class="badge-info"></cs-tooltip>
}
<ng-content select="cs-tooltip"></ng-content>